<div class="llm-configuration-list">
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    (matSortChange)="sortData($event)"
    [matSortDisableClear]="true">
    <ng-container *ngFor="let gridColumn of gridColumns">
      <ng-container
        *ngIf="gridColumn.columnName === 'data-key'"
        matColumnDef="{{ gridColumn.columnName }}">
        <ng-container *ngIf="gridColumn.sortable === true">
          <th
            mat-header-cell
            [mat-sort-header]="gridColumn.sorterFieldName"
            *matHeaderCellDef
            [style.width]="gridColumn.width"
            [style.minWidth]="gridColumn.width"
            [style.maxWidth]="gridColumn.width"
            [ngClass]="gridColumn.headerClass"
            scope="col">
            {{ gridColumn.header }}
          </th>
        </ng-container>
        <ng-container *ngIf="gridColumn.sortable !== true">
          <th
            mat-header-cell
            *matHeaderCellDef
            [style.width]="gridColumn.width"
            [style.minWidth]="gridColumn.width"
            [style.maxWidth]="gridColumn.width"
            [ngClass]="gridColumn.headerClass"
            scope="col">
            {{ gridColumn.header }}
          </th>
        </ng-container>
        <td
          mat-cell
          [ngClass]="gridColumn.cellClass"
          *matCellDef="let configuration"
          container="body">
          <div *ngIf="totalCount === 0" class="message-container">
            <div class="message-icon">
              <i class="fa-duotone fa-circle-info fa-xl"></i>
            </div>
            <div class="message-text">
              {{ 'Dashboard::Widget:NoAvailableData' | abpLocalization }}
            </div>
          </div>
          <ca-clickable-link
            [innerHtml]="configuration | objectparser : gridColumn"
            (linkClicked)="openDetails(configuration.id)"
            [showTooltipIfTruncated]="true"></ca-clickable-link>
        </td>
      </ng-container>
      <ng-container
        *ngIf="gridColumn.columnName === 'name'"
        matColumnDef="{{ gridColumn.columnName }}">
        <ng-container *ngIf="gridColumn.sortable === true">
          <th
            mat-header-cell
            [mat-sort-header]="gridColumn.sorterFieldName"
            *matHeaderCellDef
            [style.width]="gridColumn.width"
            [style.minWidth]="gridColumn.width"
            [style.maxWidth]="gridColumn.width"
            [ngClass]="gridColumn.headerClass"
            scope="col">
            {{ gridColumn.header }}
          </th>
        </ng-container>
        <ng-container *ngIf="gridColumn.sortable !== true">
          <th
            mat-header-cell
            *matHeaderCellDef
            [style.width]="gridColumn.width"
            [style.minWidth]="gridColumn.width"
            [style.maxWidth]="gridColumn.width"
            [ngClass]="gridColumn.headerClass"
            scope="col">
            {{ gridColumn.header }}
          </th>
        </ng-container>
        <td
          mat-cell
          [ngClass]="gridColumn.cellClass"
          *matCellDef="let configuration"
          container="body"
          [ngbTooltip]="configuration | objectparser : gridColumn"
          showTooltipIfTruncated>
          <ca-clickable-link
            [innerHtml]="configuration | objectparser : gridColumn"
            (linkClicked)="openDetails(configuration.id)"
            [showTooltipIfTruncated]="true"></ca-clickable-link>
        </td>
      </ng-container>
      <ng-container
        *ngIf="gridColumn.columnName === 'icons'"
        matColumnDef="{{ gridColumn.columnName }}">
        <th
          mat-header-cell
          *matHeaderCellDef
          [style.width]="gridColumn.width"
          [style.minWidth]="gridColumn.width"
          [style.maxWidth]="gridColumn.width"
          [ngClass]="gridColumn.headerClass">
          {{ gridColumn.header }}
        </th>
        <td
          mat-cell
          [ngClass]="gridColumn.cellClass"
          *matCellDef="let configuration"
          container="body"></td>
      </ng-container>
      <ng-container
        *ngIf="gridColumn.columnName !== 'name'"
        matColumnDef="{{ gridColumn.columnName }}">
        <th
          mat-header-cell
          *matHeaderCellDef
          [style.width]="gridColumn.width"
          [style.minWidth]="gridColumn.width"
          [style.maxWidth]="gridColumn.width"
          [ngClass]="gridColumn.headerClass"
          [ngbTooltip]="gridColumn.header"
          container="body"
          showTooltipIfTruncated>
          {{ gridColumn.header }}
        </th>
        <td
          mat-cell
          [ngClass]="gridColumn.cellClass"
          *matCellDef="let pronunciation"
          container="body"
          [innerHtml]="pronunciation | objectparser : gridColumn"
          [ngbTooltip]="pronunciation | objectparser : gridColumn"
          showTooltipIfTruncated></td>
      </ng-container>
    </ng-container>
    <!-- Info column -->
    <ng-container matColumnDef="info">
      <td
        mat-footer-cell
        *matFooterCellDef
        style="text-align: left"
        [attr.colspan]="displayedColumns.length">
        <span>
          <mat-paginator
            style="display: flex; justify-content: left"
            (page)="onPageChange($event)"
            [pageIndex]="currentPage"
            [length]="totalCount"
            [pageSize]="pageSize"
            class="paginator"
            hidePageSize
            showFirstLastButtons></mat-paginator>
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      class="llm-configuration-row-{{ myRowData.id }}"
      (dblclick)="onRowDoubleClick($event, myRowData.id)"
      *matRowDef="let myRowData; columns: displayedColumns"></tr>

    <tr mat-footer-row *matFooterRowDef="['info']; sticky: true"></tr>
    <tr class="mat-row" *matNoDataRow [hidden]="isLoading">
      <td class="mat-cell" [colSpan]="displayedColumns.length">
        {{ 'CA::NoDataFound' | abpLocalization }}
      </td>
    </tr>
  </table>
</div>
